<template>
  <div>
    <div
      class="flex p-2 items-center gap-3 hover:bg-slate-100 rounded-md mb-2"
      @click="toggleShowFolderItems"
    >
      <box-icon class="h-5 w-5" name="chevron-down" />
      <span v-html="highlightText(folderName)"></span>
      <span>{{ `(${folder.length})` }}</span>
    </div>
    <div v-if="showFolderItems" class="px-4 mb-5">
      <FolderContentItem
        v-for="(categoryItems, key) in groupedFolderItems"
        :folderItem="categoryItems"
        :category="key"
        :key="key"
      />
    </div>
  </div>
</template>

<script>
import { reactive, ref, onMounted } from "vue";
import FolderContentItem from "./FolderContentItem.vue";

export default {
  components: { FolderContentItem },
  name: "Folder Item",
  props: {
    folderName: {
      type: String,
      required: true,
    },
    folder: {
      type: Object,
      required: true,
    },
    highlightedText: {
      type: String,
    },
  },
  setup(props) {
    const groupedFolderItems = reactive({});
    const showFolderItems = ref(false);

    const toggleShowFolderItems = () => {
      showFolderItems.value = !showFolderItems.value;
    };

    const highlightText = (text) => {
      if (!props.highlightedText || !props.highlightedText.length) {
        return text;
      }

      let newMarkup = "";
      const specialChars = /[^A-Z0-9]/gi;
      const documentConditions = props.highlightedText
        .toLowerCase()
        .split(specialChars);

      documentConditions.forEach((condition) => {
        newMarkup += text.replace(new RegExp(condition, "gi"), (match) => {
          return '<span class="highlightText">' + match + "</span>";
        });
      });

      return newMarkup;
    };

    onMounted(() => {
      props.folder.forEach((folderItem) => {
        const lang = folderItem.Items[0].Language;
        const category = folderItem.Items[0].Category;

        if (!groupedFolderItems[category]) {
          groupedFolderItems[category] = {
            parentFolder: folderItem.Name,
          };
        }

        if (!groupedFolderItems[category][lang]) {
          groupedFolderItems[category][lang] = [];
        }

        groupedFolderItems[category][lang].push(folderItem.Items[0]);
      });
    });

    return {
      showFolderItems,
      groupedFolderItems,
      toggleShowFolderItems,
      highlightText,
    };
  },
};
</script>
